<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>

  <div class="ui divider"></div>
</h3>

<div class="content">
  <div
    class="ui basic vertical segment"
    *ngIf="watchers && watchers.length >= 1"
  >
    <!-- <h3 class="ui primary header">Company Details</h3> -->
    <div class="item" *ngFor="let watcher of watchers">
      <img
        class="watcher-image"
        src="{{ loadImage(watcher.image) }}"
        alt="chat watcher image"
      />
      <div class="watcher-details">
        <span class="watcher-name">
          {{
            watcher?.appUser?.firstName || watcher?.appUser?.lastName
              ? watcher?.appUser?.firstName + " " + watcher?.appUser?.lastName
              : watcher?.appUser?.appUserEmail
          }}</span
        >
        <span class="watcher-date">{{
          watcher.dateCreated | date: "d MMM, y"
        }}</span>
      </div>
    </div>
  </div>

  <div
    class="ui basic vertical segment"
    *ngIf="watchers && watchers.length < 1"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 200px;
    "
  >
    <div>There are no participants watching this chat</div>
  </div>
</div>
